import React from 'react';
import { UiRoutes } from '../lib/constants';
import { routeConfigType } from 'lib/typing';
import AdminUserManagement from '../screens/Products/Plural/Settings/components/UserManagement';
const SignUp = React.lazy(() => import('../screens/Products/Plural/NewSignup'));
const Login = React.lazy(() => import('../screens/Products/Plural/Login'));
const LoginOtp = React.lazy(
  () => import('../screens/Products/Plural/Login/components/LoginOtp')
);
const RegisterUser = React.lazy(
  () => import('../screens/Products/Plural/RegisterUser')
);
const WelcomeUser = React.lazy(
  () => import('../screens/Products/Plural/WelcomeUser')
);
const Payment = React.lazy(() => import('../screens/Products/Plural/payment'));
const Introduction = React.lazy(
  () => import('../screens/Products/Plural/Introduction')
);
const ImeiRequest = React.lazy(
  () => import('../screens/Products/Plural/ImeiRequest')
);
const SmartRouting = React.lazy(
  () => import('../screens/Products/Plural/SmartRouting')
);
const Offers = React.lazy(() => import('../screens/Products/Plural/Offers'));
const OffersCampaign = React.lazy(
  () =>
    import('../screens/Products/Plural/Offers/components/OffersCreateCampaign')
);

const PlansV3 = React.lazy(()=> import('../screens/Products/Subscriptions/Plans'));
const SubscriptionsV3 = React.lazy(()=> import('../screens/Products/Subscriptions/Subscriptions'));
const PresentationsV3 = React.lazy(()=> import('../screens/Products/Subscriptions/Presentations'));

const ViewGateway = React.lazy(
  () => import('../screens/Products/Plural/SmartRouting/components/ViewGateway')
);
const CreateGateway = React.lazy(
  () =>
    import('../screens/Products/Plural/SmartRouting/components/CreateGateway')
);
const Refund = React.lazy(() => import('../screens/Products/Plural/Refund'));
const Plans = React.lazy(() => import('../screens/Products/Plural/Plans'));
const PlansHistory = React.lazy(
  () => import('../screens/Products/Plural/BulkUploadHistory')
);
const Settings = React.lazy(
  () => import('../screens/Products/Plural/Settings')
);
const KnowledgeBase = React.lazy(
  () => import('../screens/Home/KnowledgeBase')
);
const SearchResults = React.lazy(
  () => import('../screens/Products/Plural/SearchResults')
);
const Settlements = React.lazy(
  () => import('../screens/Products/Plural/Settlements')
);
const Subscriptions = React.lazy(
  () => import('../screens/Products/Plural/Subscriptions')
);
const Presentations = React.lazy(
  () => import('../screens/Products/Plural/Presentations')
);
// TODO: To be integrated in next scope
const PaymentLinks = React.lazy(
  () => import('../screens/Products/Plural/PaymentLinks')
);
const PaymentLinkBulkUploadHistory = React.lazy(
  () =>
    import(
      '../screens/Products/Plural/PaymentLinks/components/BulkUploadHistory'
    )
);
// const PaymentPages = React.lazy(() => import('../screens/Products/Plural/PaymentPages'));
const Analytics = React.lazy(
  () => import('../screens/Products/Plural/Analytics')
);
const Overview = React.lazy(
  () => import('../screens/Products/Plural/Overview')
);
const BulkUploadHistory = React.lazy(
  () => import('../screens/Products/Plural/BulkUploadHistory')
);
const ImeiBulkUploadHistory = React.lazy(
  () => import('../screens/Products/Plural/ImeiBulkUploadHistory')
);
const AdminCustomRouting = React.lazy(
  () => import('../screens/Products/Plural/AdminCustomRouting')
);
const PgRouterAdmin = React.lazy(
  () => import('../screens/Products/Plural/PgRouterAdmin')
);
const MerchantListing = React.lazy(
  () => import('../screens/Products/Plural/MerchantListing')
);
const Admin_User_Management = AdminUserManagement;
const ForceRefund = React.lazy(
  () => import('../screens/Products/Plural/ForceRefund')
);
const ForceUpdateOrder = React.lazy(
  () => import('../screens/Products/Plural/ForceUpdateOrder')
);
const FeeConfiguration = React.lazy(
  () => import('../screens/Products/Plural/FeeConfiguration')
);
const CustomizePaymentLinks = React.lazy(
  () =>
    import(
      '../screens/Products/Plural/PaymentLinks/components/CustomizePaymentLinks'
    )
);
const EdgeCustomizePaymentLinks = React.lazy(
  () =>
    import(
      '../screens/Products/Edge/PaymentLinks/components/CustomizePaymentLinks'
    )
);
// const Payouts = React.lazy(() => import('../screens/Products/Payouts/Payouts'));
const IndividualPayouts = React.lazy(
  () => import('../screens/Products/Payouts/IndividualPayouts')
);
const Beneficiaries = React.lazy(
  () => import('../screens/Products/Payouts/Beneficiaries')
);
const BulkPayouts = React.lazy(
  () => import('../screens/Products/Payouts/BulkPayouts')
);
const BulkPayoutDetails = React.lazy(
  () => import('../screens/Products/Payouts/BulkPayoutDetails')
);
const BulkPayoutFailedRecords = React.lazy(
  () => import('../screens/Products/Payouts/BulkPayoutFailedRecords')
);
const PayoutSettings = React.lazy(
  () => import('../screens/Products/Payouts/Settings')
);
const BulkBeneficiaries = React.lazy(
  () => import('../screens/Products/Payouts/BulkBeneficiaries')
);
const CompleteProfile = React.lazy(
  () => import('../screens/Products/Plural/CompleteProfile')
);
const SupportRequests = React.lazy(
  () => import('../screens/Products/Plural/Settings/components/SupportRequests')
);
const Comments = React.lazy(
  () =>
    import(
      '../screens/Products/Plural/Settings/components/SupportRequests/components/Comments'
    )
);
const ToggleEnv = React.lazy(
  () => import('../screens/Products/Plural/ToggleEnv')
);
const EdgeTransactions = React.lazy(
  () => import('../screens/Products/Edge/Transactions')
);
const EdgeImeiBulkUploadHistory = React.lazy(
  () =>
    import(
      '../screens/Products/Edge/Transactions/components/ImeiBulkUploadHistory'
    )
);


const EdgeImeiBulkListInFile = React.lazy(
  () => import('../screens/Products/Edge/Transactions/components/ImeiList')
);
const OpsImeiBulkUploadHistory = React.lazy(
  () => import('../screens/Home/ImeiHistory')
);
const OpsImeiBulkListInFile = React.lazy(
  () => import('../screens/Home/ImeiList')
);
const OpsRefundBulkUploadHistory = React.lazy(
  () => import('../screens/Home/RefundHistory')
);
const OpsBulkRefundList = React.lazy(
  () => import('../screens/Home/RefundList')
);
const Mpr = React.lazy(() => import('../screens/Products/Edge/MPR'));
const EdgeRefunds = React.lazy(
  () => import('../screens/Products/Edge/Refunds')
);
const EdgeRefundBulkUploadHistory = React.lazy(
  () => import('../screens/Products/Edge/BulkUploadHistory')
);

const EdgeRefundBulkUploadHistoryV3 = React.lazy(() => import('../screens/Products/Edge/EdgeV3/Transactions/components/RefundBulkUploadHistory'));
const EdgeBulkRefundList = React.lazy(
  () => import('../screens/Products/Edge/Refunds/components/RefundList')
);
const EdgeSettlements = React.lazy(
  () => import('../screens/Products/Edge/Settlements')
);
const UpdatedEdgeSettlements = React.lazy(
  () => import('../screens/Products/Edge/UpdatedSettlements')
);

const PendingSettlements = React.lazy(
  () => import('../screens/Products/Edge/UpdatedSettlements/PendingSettlements')
);

const EdgeDisputes = React.lazy(
  () => import('../screens/Products/Edge/Disputes')
);

const EdgeDisputeDetails = React.lazy(
  () => import('../screens/Products/Edge/Disputes/components/DisputeDetails')
);

const UpdatedEdgeSettlementsDetails = React.lazy(
  () => import('../screens/Products/Edge/UpdatedSettlementsDetails')
);

const UpdatedSettlementTransactionDetails = React.lazy(
  () => import('../screens/Products/Edge/UpdatedSettlementTransactionDetails')
);

const UnifiedMerchantListing = React.lazy(
  () => import('../screens/Home/UnifiedMerchantListing')
);

const UnifiedMerchantVersionListing = React.lazy(
  () => import('../screens/Home/UnifiedMerchantVersionListing')
);
const EdgeSettings = React.lazy(
  () => import('../screens/Products/Edge/Settings')
);
const EdgePaymentLinks = React.lazy(
  () => import('../screens/Products/Edge/PaymentLinks')
);

const EdgeOverview = React.lazy(
  () => import('../screens/Products/Edge/Overview')
);

const EdgeCheckoutInsights = React.lazy(() => import('../screens/Products/Edge/Overview/components/CheckoutInsights'));

const AllMerchants = React.lazy(
  () => import('../screens/Products/Edge/AllMerchants')
);

const MerchantOnboarding = React.lazy(
  () => import('../screens/Products/Edge/AllMerchants/components/MerchantOnboarding')
);
const MerchantBulkUploadHistory = React.lazy(()=> import('../screens/Products/Edge/AllMerchants/components/MerchantOnboarding/components/BulkUploadHistory/BulkUploadHistory'));
export const EdgeV3Payments = React.lazy(
  () => import('../screens/Products/Edge/EdgeV3/Transactions')
);

const EdgeV3PaymentDetails = React.lazy(
  () => import('../screens/Products/Edge/EdgeV3/Transactions/TransactionDetails')
);

const EdgeV3OrderDetails = React.lazy(
  () => import('../screens/Products/Edge/EdgeV3/Transactions/OrderDetails')
);
const ImeiValidation = React.lazy(
  () => import('../screens/Products/Edge/Transactions/components/ImeiValidation')
);

const ImeiValidationV3 = React.lazy(
  () => import('../screens/Products/Edge/EdgeV3/Transactions/components/ImeiValidation')
);

const V3ImeiBulkUploadHistory = React.lazy(
  () =>
    import(
      '../screens/Products/Edge/EdgeV3/Transactions/components/ImeiBulkUploadHistory'
    )
);

const BulkPaymentDetailsHistory = React.lazy(
  () =>
    import(
      '../screens/Products/Edge/EdgeV3/Transactions/components/BulkPaymentDetailsHistory'
    )
);


const UnifiedMerchantVersionUpdate = React.lazy(
  () => import('../screens/Home/UnifiedMerchantVersionUpdate')
);
const Summary = React.lazy(
  () => import('../screens/Partner/Summary')
);
const Merchants = React.lazy(
  () => import('../screens/Partner/Merchants')
);
const PartnerMerchantOnboarding = React.lazy(
  () => import('../screens/Partner/Merchants/MerchantOnboarding')
);
const PartnerInviteMerchant = React.lazy(
  () => import('../screens/Partner/Merchants/MerchantOnboarding/InviteMerchantPage')
);
const PartnerReviewCharges = React.lazy(
  () => import('../screens/Partner/Merchants/ReviewCharges')
);
const ReportCustomization = React.lazy(() => import('../screens/Partner/PartnerReports/components/ReportCustomize'));
const Transactions = React.lazy(
  () => import('../screens/Partner/Transactions')
);
const Commissions = React.lazy(
  () => import('../screens/Partner/Commissions')
);
const IncentivePlan = React.lazy(
  () => import('../screens/Partner/IncentivePlan')
);
const Reports = React.lazy(
  () => import('../screens/Partner/PartnerReports')
);
const PartnerSettings = React.lazy(
  () => import('../screens/Partner/PartnerSettings'));

const CompleteProfileSection = React.lazy(
  () => import('../components/UserVerificationBox')
);

const MdrAcceptancePage = React.lazy(
  () => import('../screens/Products/UserVerificationProcess/MdrAcceptance')
);

const ProductsSelctionPage = React.lazy(
  () => import('../screens/Products/UserVerificationProcess/ProductSelection')
);

const PanVerificationPage = React.lazy(
  () => import('../screens/Products/UserVerificationProcess/PanVerification')
);

const BusinessVerificationPage = React.lazy(
  () => import('../screens/Products/UserVerificationProcess/BusinessDetails')
);

const KYCVerificationPage = React.lazy(
  () => import('../screens/Products/UserVerificationProcess/KYC')
);

const KYCSignAgreementPage = React.lazy(
  () => import('../screens/Products/UserVerificationProcess/KYCSignAgreement')
);

const KYCSignAgreementPagePublic = React.lazy(
  () => import('../screens/Products/UserVerificationProcess/KYCSignAgreement')
);

const BankAccountVerificationPage = React.lazy(
  () => import('../screens/Products/UserVerificationProcess/BankAccount')
);

const ReviewDetailsPage = React.lazy(
  () => import('../screens/Products/UserVerificationProcess/ReviewProfileDetails')
);

const BusinessProofPage = React.lazy(
  () => import('../screens/Products/UserVerificationProcess/BusinessProof')
);

const ProfileSubmitted = React.lazy(
  () => import('../screens/Products/UserVerificationProcess/ProfileSubmitted')
);

const EmailVerificationPage = React.lazy(
  () => import('../components/EmailVerificationDummy')
);

const VideoKycPage = React.lazy(
  ()=> import('../screens/Products/UserVerificationProcess/VideoKYC')
);

const dummyPage = React.lazy(
  ()=> import('../screens/Products/UserVerificationProcess/Dummy')
);

const uploadDocumentPage = React.lazy(
  ()=> import('../screens/Products/UserVerificationProcess/UploadDocument/index')
);

const SoftRejectionPage = React.lazy(
  ()=> import('../screens/Products/UserVerificationProcess/SoftRejection/index')
);

const uploadDocumentPagePublic = React.lazy(
  ()=> import('../screens/Products/UserVerificationProcess/UploadDocument/index')
);

const SoftRejectionUploadDocumentPagePublic = React.lazy(
  ()=> import('../screens/Products/UserVerificationProcess/SoftRejection/index')
);

const uploadCompanyDocumentPage = React.lazy(
  ()=> import('../screens/Products/UserVerificationProcess/UploadCompanyDocument/index')
);

const solePropDocumentsUploadPage = React.lazy(
  ()=> import('../screens/Products/UserVerificationProcess/SolePropDocumentsUpload/index')
);

const OdsDetailsPage = React.lazy(()=> import('../screens/Products/Edge/UpdatedSettlements/OdsSettlementPage'));
const AdminTransaction=React.lazy(()=>import('../screens/Products/RcuDashboard/AdminTransactions'));
const AdminRcuMerchant=React.lazy(()=>import('../screens/Products/RcuDashboard/AdminRcuMerchant'));

const paymentModesOverview = React.lazy(()=> import('../screens/Products/Edge/Settings/components/PaymentModes/Overview'));
const paymentModesDetails = React.lazy(()=> import('../screens/Products/Edge/Settings/components/PaymentModes/Details'));

// const EdgePaymentLinkBulkUploadHistory = React.lazy(
//   () =>
//     import('../screens/Products/Edge/PaymentLinks/components/BulkUploadHistory')
// );
const EdgePaymentLinkBulkUploadHistory = React.lazy(
  () =>
    import('../screens/Products/Edge/PaymentLinks/components/BulkUploadHistory')
);

const BrandWallet = React.lazy(
  () => import('../screens/Products/Edge/BrandWallet')
);

const routeConfig: Array<routeConfigType> = [
  {
    path: UiRoutes.SIGNUP,
    component: SignUp,
    key: 'signup-screen',
    exact: true,
    layout: 'public',
  },
  {
    path: UiRoutes.PARTNER_SUMMARY,
    component: Summary,
    key: 'partner-summary',
    exact: true,
    layout: 'partner-layout',
  },
  {
    path: UiRoutes.PARTNER_ALL_MERCHANTS,
    component: Merchants,
    key: 'partner-all-merchants',
    exact: true,
    layout: 'partner-layout',
  },
  {
    path: UiRoutes.PARTNER_MERCHANT_ONBOARDING,
    component: PartnerMerchantOnboarding,
    key: 'partner-merchant-onboarding',
    exact: true,
    layout: 'partner-layout',
  },
  {
    path: UiRoutes.PARTNER_INVITE_MERCHANT,
    component: PartnerInviteMerchant,
    key: 'partner-invite-merchant',
    exact: true,
    layout: 'partner-layout',
  },
  {
    path: UiRoutes.PARTNER_MERCHANT_BULK_UPLOAD_HISTIORY,
    component: MerchantBulkUploadHistory,
    key: 'partner-merchant-bulk-upload-history',
    exact: true,
    layout: 'partner-layout',
  },
  {
    path: UiRoutes.PARTNER_REVIEW_CHARGES,
    component: PartnerReviewCharges,
    key: 'partner-review-charges',
    exact: true,
    layout: 'partner-layout',
  },
  {
    path: UiRoutes.PARTNER_TRANSACTIONS,
    component: Transactions,
    key: 'partner-all-transactions',
    exact: true,
    layout: 'partner-layout',
  },
  {
    path: UiRoutes.ODS_DETAIL_PAGE,
    component: OdsDetailsPage,
    key: 'ods-details-page',
    exact: true,
    layout: 'edge-private',
  },
  {
    path: UiRoutes.PARTNER_COMMISSIONS,
    component: Commissions,
    key: 'partner-commissions',
    exact: true,
    layout: 'partner-layout',
  },
  {
    path: UiRoutes.PARTNER_INCENTIVE_PLAN,
    component: IncentivePlan,
    key: 'partner-incentive-plan',
    exact: true,
    layout: 'partner-layout',
  },
  {
    path: UiRoutes.ADMIN_TRANSACTIONS,
    component: AdminTransaction,
    key: 'admin-user-transaction',
    exact: true,
    layout: 'admin',
  },
  {
    path: UiRoutes.ADMIN_RCU_MERCHANT,
    component: AdminRcuMerchant,
    key: 'admin-rcu-merchant',
    exact: true,
    layout: 'admin',
  },
  {
    path: UiRoutes.PARTNER_REPORTS,
    component: Reports,
    key: 'partner-layout',
    exact: true,
    layout: 'partner-layout',
  },
  {
    path: UiRoutes.PARTNER_SETTINGS,
    component: PartnerSettings,
    key: 'partner-layout',
    exact: true,
    layout: 'partner-layout',
  },
  {
    path: UiRoutes.LOGIN,
    component: Login,
    key: 'recentlyUsed-payment-screen',
    exact: true,
    layout: 'public',
  },
  {
    path: UiRoutes.PUBLIC_KYC_AGREEMENT_SIGN,
    component: KYCSignAgreementPagePublic,
    key: 'public-kyc-sign-agreement-screen',
    exact: true,
    layout: 'public-self-serve-profile',
  },
  {
    path: UiRoutes.PUBLIC_UPLOAD_DOCUMENTS,
    component: uploadDocumentPagePublic,
    key: 'public-upload-documents-screen',
    exact: true,
    layout: 'public-self-serve-profile',
  },
  {
    path: UiRoutes.PUBLIC_SOFT_REJECTION_UPLOAD_DOCUMENTS,
    component: SoftRejectionUploadDocumentPagePublic,
    key: 'soft-rejection-public-upload-documents-screen',
    exact: true,
    layout: 'public-self-serve-profile',
  },
  {
    path: UiRoutes.LOGIN_OTP,
    component: LoginOtp,
    key: 'login-otp-screen',
    exact: true,
    layout: 'public',
  },
  {
    path: UiRoutes.REGISTER_USER,
    component: RegisterUser,
    key: 'register-user-screen',
    exact: true,
    layout: 'public',
  },
  {
    path: UiRoutes.WELCOME_USER,
    component: WelcomeUser,
    key: 'welcome-user-screen',
    exact: true,
    layout: 'public',
  },
  {
    path: UiRoutes.PAYMENT,
    component: Payment,
    key: 'payment',
    exact: true,
    layout: 'merchant',
  },
  {
    path: UiRoutes.TOGGLEENV,
    component: ToggleEnv,
    key: 'ToggleEnv',
    exact: true,
    layout: 'merchant',
  },
  {
    path: UiRoutes.INTRODUCTION,
    component: Introduction,
    key: 'introduction',
    exact: true,
    layout: 'merchant',
  },
  {
    path: UiRoutes.VARIFY_IMEI,
    component: ImeiRequest,
    key: 'introduction',
    exact: true,
    allowedPermission: ['VERIFY_IMEI'],
    layout: 'merchant',
  },
  {
    path: UiRoutes.CREATE_GATEWAY,
    component: CreateGateway,
    key: 'create-gateway',
    allowedPermission: ['CREATE_GATEWAY'],
    layout: 'merchant',
  },
  {
    path: UiRoutes.VIEW_GATEWAY_DETAILS(':gateway'),
    component: ViewGateway,
    key: 'view-gateway',
    exact: true,
    allowedPermission: ['UPDATE_GATEWAY_CONFIG', 'VIEW_GATEWAY_CONFIG'],
    layout: 'merchant',
  },
  {
    path: UiRoutes.SMART_ROUTING,
    component: SmartRouting,
    key: 'smart-routing',
    exact: true,
    layout: 'merchant',
  },
  {
    path: UiRoutes.OFFERS,
    component: Offers,
    key: 'offers',
    exact: true,
    allowedPermission: ['VIEW_OFFERS'],
    layout: 'merchant',
  },
  {
    path: UiRoutes.OFFERSNEWCAMPAIGN,
    component: OffersCampaign,
    key: 'offersCreateCampaign',
    exact: true,
    allowedPermission: ['CREATE_OFFERS'],
    layout: 'merchant',
  },
  {
    path: UiRoutes.OFFERSCLONECAMPAIGN,
    component: OffersCampaign,
    key: 'offersCreateCampaign',
    exact: true,
    allowedPermission: ['CREATE_OFFERS'],
    layout: 'merchant',
  },
  {
    path: UiRoutes.REFUND_BULK_UPLOAD_HISTORY,
    component: BulkUploadHistory,
    key: 'refund-bulk-upload-history',
    exact: true,
    layout: 'merchant',
  },
  {
    path: UiRoutes.IMEI_BULK_UPLOAD_HISTORY,
    component: ImeiBulkUploadHistory,
    key: 'imei-bulk-upload-history',
    exact: true,
    layout: 'merchant',
  },
  {
    path: UiRoutes.REFUNDS,
    component: Refund,
    key: 'refund',
    exact: true,
    layout: 'merchant',
  },
  {
    path: UiRoutes.PLANS,
    component: Plans,
    key: 'plans',
    exact: true,
    layout: 'merchant',
  },
  {
    path: UiRoutes.PLANS_HISTORY,
    component: PlansHistory,
    key: 'plansHistory',
    exact: true,
    layout: 'merchant',
  },
  {
    path: UiRoutes.SETTINGS,
    component: Settings,
    key: 'settings',
    exact: true,
    layout: 'merchant',
  },
  {
    path: UiRoutes.PAYMENT_MODES_OVERVIEW,
    component: paymentModesOverview,
    key: 'edgeSettings',
    exact: true,
    layout: 'edge-private',
  },
  {
    path: UiRoutes.PAYMENT_MODES_DETAILS,
    component: paymentModesDetails,
    key: 'edgeSettings',
    exact: true,
    layout: 'edge-private',
  },
  {
    path: UiRoutes.SEARCH_RESULTS,
    component: SearchResults,
    key: 'search-results',
    exact: true,
    layout: 'merchant',
  },
  {
    path: UiRoutes.SETTLEMENTS,
    component: Settlements,
    key: 'settlements',
    exact: true,
    layout: 'merchant',
  },
  {
    path: UiRoutes.SUBSCRIPTIONS,
    component: Subscriptions,
    key: 'subscriptions',
    exact: true,
    layout: 'merchant',
  },
  {
    path: UiRoutes.PRESENTATIONS,
    component: Presentations,
    key: 'presentations',
    exact: true,
    layout: 'merchant',
  },
  // TODO: To be integrated in next scope
  {
    path: UiRoutes.PAYMENT_LINKS,
    component: PaymentLinks,
    key: 'payment-links',
    exact: true,
    layout: 'merchant-payment-link',
  },
  {
    path: UiRoutes.PAYMENT_LINK_BULK_UPLOAD_HISTORY,
    component: PaymentLinkBulkUploadHistory,
    key: 'payment-links-bulk-upload-history',
    exact: true,
    layout: 'merchant-payment-link',
  },
  // {
  //   path: UiRoutes.PAYMENT_PAGES,
  //   component: PaymentPages,
  //   key: 'payment-pages',
  //   exact: true,
  //   layout: 'merchant',
  // },
  {
    path: UiRoutes.ANALYTICS,
    component: Analytics,
    key: 'analytics',
    exact: true,
    layout: 'merchant',
  },
  {
    path: UiRoutes.OVERVIEW,
    component: Overview,
    key: 'analytics',
    exact: true,
    layout: 'merchant',
  },
  // {
  //   path: UiRoutes.PAYOUTS,
  //   component: Payouts,
  //   key: 'payouts',
  //   exact: true,
  //   layout: 'merchant-payout',
  // },
  {
    path: UiRoutes.INDIVIDUAL_PAYOUTS,
    component: IndividualPayouts,
    key: 'individualPayouts',
    exact: true,
    layout: 'merchant-payout',
  },
  {
    path: UiRoutes.BENEFICIARIES,
    component: Beneficiaries,
    key: 'beneficiaries',
    exact: true,
    layout: 'merchant-payout',
  },
  {
    path: UiRoutes.BULK_PAYOUTS,
    component: BulkPayouts,
    key: 'bulkPayouts',
    exact: true,
    layout: 'merchant-payout',
  },
  {
    path: UiRoutes.BULK_PAYOUT_DETAILS,
    component: BulkPayoutDetails,
    key: 'bulkPayoutDetails',
    exact: true,
    layout: 'merchant-payout',
  },
  {
    path: UiRoutes.BULK_PAYOUT_FAILED_RECORDS,
    component: BulkPayoutFailedRecords,
    key: 'bulkPayoutFailedRecords',
    exact: true,
    layout: 'merchant-payout',
  },
  {
    path: UiRoutes.PAYOUTS_SETTINGS,
    component: PayoutSettings,
    key: 'payoutSettings',
    exact: true,
    layout: 'merchant-payout',
  },
  {
    path: UiRoutes.BULK_BENEFICIARIES,
    component: BulkBeneficiaries,
    key: 'bulkBeneficiaries',
    exact: true,
    layout: 'merchant-payout',
  },
  {
    path: UiRoutes.ADMIN_LOGIN,
    component: Login,
    key: 'admin-login',
    exact: true,
    layout: 'public',
  },
  {
    path: UiRoutes.ADMIN_CUSTOM_ROUTING,
    component: AdminCustomRouting,
    key: 'admin-custom-routing',
    exact: true,
    layout: 'admin',
  },
  {
    path: UiRoutes.PG_ROUTER_ADMIN,
    component: PgRouterAdmin,
    key: 'pg-router-admin',
    exact: false,
    allowedPermission: ['PAYPREDICT_CHECKER', 'PAYPREDICT_MAKER', 'OBSERVABILITY READ'],
    layout: 'admin',
  },
  {
    path: UiRoutes.MERCHANT_LISTING,
    component: MerchantListing,
    key: 'plural-merchant-listing',
    exact: true,
    layout: 'admin',
  },
  {
    path: UiRoutes.ADMIN_ANALYTICS,
    component: Analytics,
    key: 'admin-analytics',
    exact: true,
    layout: 'admin',
  },
  {
    path: UiRoutes.ADMIN_USER_MANAGEMENT,
    component: Admin_User_Management,
    key: 'admin-user-management',
    exact: true,
    layout: 'admin',
  },
  {
    path: UiRoutes.FORCE_REFUND_ADMIN,
    component: ForceRefund,
    key: 'force-refund-admin',
    exact: true,
    layout: 'admin',
  },
  {
    path: UiRoutes.FORCE_UPDATE_ORDER_ADMIN,
    component: ForceUpdateOrder,
    key: 'force-update-order-admin',
    exact: true,
    layout: 'admin',
  },
  {
    path: UiRoutes.FEE_CONFIGURATION_ADMIN,
    component: FeeConfiguration,
    key: 'fee-configuration-admin',
    exact: true,
    layout: 'admin',
  },
  {
    path: UiRoutes.KNOWLEDGE_BASE_ADMIN,
    component: KnowledgeBase,
    key: 'knowledge-base-admin',
    exact: true,
    allowedPermission: ['UPDATE_KNOWLEDGE_BASE'],
    layout: 'admin',
  },
  {
    path: UiRoutes.CUSTOMIZE_PAYMENT_LINKS,
    component: CustomizePaymentLinks,
    key: 'customize-payment-links',
    allowedPermission: ['CREATE_PAYMENT_LINKS'],
    layout: 'merchant-payment-link',
  },
  {
    path: UiRoutes.EDGE_CUSTOMIZE_PAYMENT_LINKS,
    component: EdgeCustomizePaymentLinks,
    key: 'edge-customize-payment-links',
    allowedPermission: ['CREATE_PAYMENT_LINKS'],
    layout: 'merchant-payment-link',
  },
  {
    path: UiRoutes.PROFILE,
    component: CompleteProfile,
    key: 'Profile',
    layout: 'profile',
  },
  {
    path: UiRoutes.SUPPORTREQUESTS,
    component: SupportRequests,
    key: 'SupportRequests',
    layout: 'merchant',
  },
  {
    path: UiRoutes.SUPPORTREQUESTSDETAILS,
    component: Comments,
    key: 'SupportRequests',
    layout: 'merchant',
  },
  {
    path: UiRoutes.EDGE_TRANSACTIONS,
    component: EdgeTransactions,
    key: 'edgeTransaction',
    exact: true,
    layout: 'edge-private',
  },
  {
    path: UiRoutes.IMEI_VALIDATION,
    component: ImeiValidation,
    key: 'imei-validation',
    exact: true,
    layout: 'edge-private',
  },
  {
    path: UiRoutes.EDGE_IMEI_BULK_UPLOAD_HISTORY,
    component: EdgeImeiBulkUploadHistory,
    key: 'edge-imei-bulk-upload-history',
    exact: true,
    layout: 'edge-private',
    allowedPermission: ['VIEW_BULK_IMEI', 'CREATE_BULK_IMEI'],
  },
  {
    path: UiRoutes.EDGE_IMEI_BULK_UPLOAD_HISTORY_IMEI,
    component: EdgeImeiBulkListInFile,
    key: 'edge-imei-bulk-upload-history',
    exact: true,
    layout: 'edge-private',
    allowedPermission: ['VIEW_BULK_IMEI', 'CREATE_BULK_IMEI'],
  },
  {
    path: UiRoutes.EDGE_REFUNDS,
    component: EdgeRefunds,
    key: 'edgeRefunds',
    exact: true,
    layout: 'edge-private',
  },
  {
    path: UiRoutes.EDGE_REFUNDS_BULK_UPLOAD_HISTORY,
    component: EdgeRefundBulkUploadHistory,
    key: 'edge-refund-bulk-upload-history',
    exact: true,
    layout: 'edge-private',
    allowedPermission: ['VIEW_BULK_REFUND', 'CREATE_BULK_REFUND'],
  },
  {
    path: UiRoutes.EDGE_REFUNDS_BULK_UPLOAD_HISTORY_REFUND,
    component: EdgeBulkRefundList,
    key: 'edge-refund-bulk-upload-history-refund',
    exact: true,
    layout: 'edge-private',
    allowedPermission: ['VIEW_BULK_REFUND', 'CREATE_BULK_REFUND'],
  },
  {
    path: UiRoutes.EDGE_SETTLEMENTS,
    component: EdgeSettlements,
    key: 'edgeSettlements',
    exact: true,
    layout: 'edge-private',
  },
  {
    path: UiRoutes.UPDATED_EDGE_SETTLEMENTS,
    component: UpdatedEdgeSettlements,
    key: 'edgeSettlements',
    exact: true,
    layout: 'edge-private',
  },
  {
    path: UiRoutes.EDGE_PENDING_SETTLEMENTS,
    component: PendingSettlements,
    key: 'edgePendingSettlements',
    exact: true,
    layout: 'edge-private',
  },
  {
    path: UiRoutes.EDGE_DISPUTES,
    component: EdgeDisputes,
    key: 'edgeDisputes',
    exact: true,
    layout: 'edge-private',
  },
  {
    path: UiRoutes.EDGE_DISPUTE_DETAILS,
    component: EdgeDisputeDetails,
    key: 'edgeDisputeDetails',
    exact: true,
    layout: 'edge-private',
  },
  {
    path: UiRoutes.EDGE_SETTLEMENT_DETAILS,
    component: UpdatedEdgeSettlementsDetails,
    key: 'edgeSettlementsDetails',
    exact: true,
    layout: 'edge-private',
  },
  {
    path: UiRoutes.EDGE_SETTLEMENT_TRANSACTION_DETAILS,
    component: UpdatedSettlementTransactionDetails,
    key: 'edgeSettlementsTransactionDetails',
    exact: true,
    layout: 'edge-private',
  },
  {
    path: UiRoutes.EDGE_OVERVIEW,
    component: EdgeOverview,
    key: 'edge-overview',
    exact: true,
    layout: 'edge-private',
  },
  {
    path: UiRoutes.ALL_MERCHANTS,
    component: AllMerchants,
    key: 'all-merchants',
    exact: true,
    layout: 'edge-private',
  },
  {
    path: UiRoutes.MERCHANT_ONBOARDING,
    component: MerchantOnboarding,
    key: 'merchant-onboarding',
    exact: true,
    layout: 'edge-private',
  },
    {
    path: UiRoutes.MERCHANT_BULK_UPLOAD_HISTIORY,
    component: MerchantBulkUploadHistory,
    key: 'merchant-bulk-upload-history',
    exact: true,
    layout: 'edge-private',
  },
  {
    path: UiRoutes.EDGE_OVERVIEW_CHECKOUT_INSIGHTS,
    component: EdgeCheckoutInsights,
    key: 'edge-overview-checkout-insights',
    exact: true,
    layout: 'edge-private',
  },
  {
    path: UiRoutes.UNIFIED_MERCHANT_LISTING,
    component: UnifiedMerchantListing,
    key: 'unified-merchant-listing',
    exact: true,
    layout: 'admin',
  },
  {
    path: UiRoutes.UNIFIED_MERCHANT_VERSION_LISTING,
    component: UnifiedMerchantVersionListing,
    key: 'unified-merchant-version-listing',
    exact: true,
    layout: 'admin',
  },
  {
    path: UiRoutes.EDGE_SETTINGS,
    component: EdgeSettings,
    key: 'edgeSettings',
    exact: true,
    layout: 'edge-private',
  },
  {
    path: UiRoutes.EDGE_PAYMENT_LINKS,
    component: EdgePaymentLinks,
    key: 'edgePaymentLnks',
    exact: true,
    layout: 'edge-merchant-payment-link',
  },
  {
    path: UiRoutes.BRAND_WALLET,
    component: BrandWallet,
    key: 'brand-wallet',
    exact: true,
    layout: 'edge-private',
  },
  {
    path: UiRoutes.EDGE_PAYMENT_LINK_BULK_UPLOAD_HISTORY,
    component: EdgePaymentLinkBulkUploadHistory,
    key: 'edge-payment-links-bulk-upload-history',
    exact: true,
    layout: 'merchant-payment-link',
  },
  {
    path: UiRoutes.EDGE_MPR_SETTLEMENTS,
    component: Mpr,
    key: 'edgeSettlements',
    exact: true,
    layout: 'edge-private',
    allowedPermission: ['GET_MPR'],
  },
  {
    path: UiRoutes.OPS_IMEI_BULK_UPLOAD_HISTORY,
    component: OpsImeiBulkUploadHistory,
    key: 'ops-imei-bulk-upload-history',
    exact: true,
    layout: 'admin',
    allowedPermission: ['VIEW_OPS_PORTAL'],
  },
  {
    path: UiRoutes.OPS_IMEI_BULK_UPLOAD_HISTORY_IMEI,
    component: OpsImeiBulkListInFile,
    key: 'ops-imei-bulk-upload-history',
    exact: true,
    layout: 'admin',
    allowedPermission: ['VIEW_OPS_PORTAL'],
  },
  {
    path: UiRoutes.OPS_REFUNDS_BULK_UPLOAD_HISTORY,
    component: OpsRefundBulkUploadHistory,
    key: 'ops-refund-bulk-upload-history',
    exact: true,
    layout: 'admin',
    allowedPermission: ['VIEW_OPS_PORTAL'],
  },
  {
    path: UiRoutes.OPS_REFUNDS_BULK_UPLOAD_HISTORY_REFUND,
    component: OpsBulkRefundList,
    key: 'ops-refund-bulk-upload-history-refund',
    exact: true,
    layout: 'admin',
    allowedPermission: ['VIEW_OPS_PORTAL'],
  },
  {
    path: UiRoutes.V3_PAYMENTS,
    component: EdgeV3Payments,
    key: 'edgeV3Transaction',
    exact: true,
    layout: 'edge-private',
  },
  {
  path: UiRoutes.V3_REFUNDS,    
  component: EdgeV3Payments,     
  key: 'edgeV3Refunds',
  exact: true,
  layout: 'edge-private',
},
  {
    path: UiRoutes.V3_PLANS,
    component: PlansV3,
    key: 'planV3',
    exact: true,
    layout: 'merchant-subscription',
  },
  {
    path: UiRoutes.V3_SUBSCRIPTIONS,
    component: SubscriptionsV3,
    key: 'SubscriptionsV3',
    exact: true,
    layout: 'merchant-subscription',
  },
  {
    path: UiRoutes.V3_PRESENTATIONS,
    component: PresentationsV3,
    key: 'PresentationsV3',
    exact: true,
    layout: 'merchant-subscription',
  },
  {
    path: UiRoutes.V3_PAYMENTS_DETAILS,
    component: EdgeV3PaymentDetails,
    key: 'edgeV3TransactionDetails',
    exact: true,
    layout: 'edge-private',
  },
  {
    path: UiRoutes.V3_ORDER_DETAILS,
    component: EdgeV3OrderDetails,
    key: 'edgeV3OrderDetails',
    exact: true,
    layout: 'edge-private',
  },
    {
    path: UiRoutes.V3_REFUND_DETAILS,
    component: EdgeV3OrderDetails,
    key: 'edgeV3RefundDetails',
    exact: true,
    layout: 'edge-private',
  },
  {
    path: UiRoutes.V3_REFUND_PAYMENT_DETAILS,
    component: EdgeV3PaymentDetails,
    key: 'edgeV3RefundPaymentDetails',
    exact: true,
    layout: 'edge-private',
  },
  {
    path: UiRoutes.IMEI_VALIDATION_V3,
    component: ImeiValidationV3,
    key: 'edgeV3IMEIValidation',
    exact: true,
    layout: 'edge-private',
  },
  {
    path: UiRoutes.IMEI_BULK_UPLOAD_HISTORY_V3,
    component: V3ImeiBulkUploadHistory,
    key: 'edgeV3IMEIValidation',
    exact: true,
    layout: 'edge-private',
  },
  {
    path: UiRoutes.BULK_PAYMENT_DETAILS_HISTORY,
    component: BulkPaymentDetailsHistory,
    key: 'edgeV3BulkPaymentDetailsHistory',
    exact: true,
    layout: 'edge-private',
  },
  {
    path: UiRoutes.IMEI_BULK_UPLOAD_HISTORY_IMEI_V3,
    component: EdgeImeiBulkListInFile,
    key: 'edgeV3IMEIValidation',
    exact: true,
    layout: 'edge-private',
    allowedPermission: ['VIEW_BULK_IMEI', 'CREATE_BULK_IMEI'],
  },
  {
    path: UiRoutes.EDGE_REFUNDS_BULK_UPLOAD_HISTORY_V3,
    component: EdgeRefundBulkUploadHistoryV3,
    key: 'edgeV3RefundBulkUpload',
    exact: true,
    layout: 'edge-private',
  },
  {
    path: UiRoutes.EDGE_REFUNDS_BULK_UPLOAD_HISTORY_LIST_V3,
    component: EdgeBulkRefundList,
    key: 'edgeV3RefundBulkUpload',
    exact: true,
    layout: 'edge-private',
  },
  {
    path: UiRoutes.UNIFIED_MERCHANT_VERSION_UPDATE,
    component: UnifiedMerchantVersionUpdate,
    key: 'merchantVersionUpdate',
    exact: true,
    layout: 'admin',
  },
  {
    path: UiRoutes.MERCHANT_REPORT,
    component: Reports,
    key: 'partner-layout',
    exact: true,
    layout: 'edge-private',
  },
  {
    path: UiRoutes.COMPLETE_PROFILE,
    component: CompleteProfileSection,
    key: 'complete-profile',
    exact: true,
    layout: 'complete-profile',
  },
  {
    path: UiRoutes.MDR_ACCEPTANCE,
    component: MdrAcceptancePage,
    key: 'userVerificationMdrAcceptance',
    exact: true,
    layout: 'complete-profile',
  },
  {
    path: UiRoutes.SELECT_PRODUCTS,
    component: ProductsSelctionPage,
    key: 'userVerificationProductSelction',
    exact: true,
    layout: 'complete-profile',
  },
  {
    path: UiRoutes.PAN_VERIFICATION,
    component: PanVerificationPage,
    key: 'userVerificationPanVerification',
    exact: true,
    layout: 'complete-profile',
  },
  {
    path: UiRoutes.BUSINESS_DETAILS,
    component: BusinessVerificationPage,
    key: 'userVerificationBusinessVerification',
    exact: true,
    layout: 'complete-profile',
  },
  {
    path: UiRoutes.KYC_VERIFICATION,
    component: KYCVerificationPage,
    key: 'userVerificationKYCVerification',
    exact: true,
    layout: 'complete-profile',
  },
  {
    path: UiRoutes.KYC_AGREEMENT_SIGN,
    component: KYCSignAgreementPage,
    key: 'userKYCSignAgreement',
    exact: true,
    layout: 'complete-profile',
  },
  {
    path: UiRoutes.VIDEO_KYC_VERIFICATION,
    component: VideoKycPage,
    key: 'userVerificationKYCVerification',
    exact: true,
    layout: 'complete-profile',
  },
  {
    path: UiRoutes.DOCUMENTS_UPLOAD,
    component: uploadDocumentPage,
    key: 'userVerificationUploadDocuments',
    exact: true,
    layout: 'complete-profile',
  },
  {
    path: UiRoutes.SOLE_PROP_DOCUMENTS_UPLOAD,
    component: solePropDocumentsUploadPage,
    key: 'userVerificationUploadDocumentsSoleProp',
    exact: true,
    layout: 'complete-profile',
  },
  {
    path: UiRoutes.UPLOAD_COMPANY_DOCUMENTS,
    component: uploadCompanyDocumentPage,
    key: 'userVerificationUploadDocumentsCompany',
    exact: true,
    layout: 'complete-profile',
  },
  {
    path: UiRoutes.PUBLIC_UPLOAD_COMPANY_DOCUMENTS,
    component: uploadDocumentPagePublic,
    key: 'userVerificationUploadDocumentsCompanyDirector',
    exact: true,
    layout: 'public-self-serve-profile',
  },
  {
    
    path: UiRoutes.DUMMY_URL,
    component: dummyPage,
    key: 'userVerificationKYCVerification',
    exact: true,
    layout: 'public',
  },
  {
    path: UiRoutes.BANK_DETAILS,
    component: BankAccountVerificationPage,
    key: 'userVerificationBankAccountVerification',
    exact: true,
    layout: 'complete-profile',
  },
  {
    path: UiRoutes.REVIEW_DETAILS,
    component: ReviewDetailsPage,
    key: 'userVerificationReviewDetails',
    exact: true,
    layout: 'complete-profile',
  },
  {
    path: UiRoutes.BUSINESS_PROOF_SUBMITTION,
    component: BusinessProofPage,
    key: 'userVerificationBusiness',
    exact: true,
    layout: 'complete-profile',
  },
  {
    path: UiRoutes.PROFILE_SUBMITTED,
    component: ProfileSubmitted,
    key: 'userVerificationProfileSubmittion',
    exact: true,
    layout: 'complete-profile',
  },
  {
    path: UiRoutes.SOFT_REJECTION,
    component: SoftRejectionPage,
    key: 'userVerificationSoftRejection',
    exact: true,
    layout: 'complete-profile',
  },
  {
    path: UiRoutes.EMAIL_VERIFICATION,
    component: EmailVerificationPage,
    key: 'mailVerification',
    exact: true,
    layout: 'public',
  },
  {
    path: UiRoutes.REPORT_CUSTOMIZATION,
    component: ReportCustomization,
    key: 'partner-layout',
    exact: true,
    layout: 'partner-layout',
  },
];


export default routeConfig;
